<template>
  <div class="workspace-page">
    <NavBar />
    <SideBar :is-condensed="true" :type="$store.state.layout.leftSidebarType" :width="$store.state.layout.layoutWidth" />
    <main style="background-color: #f4f4f4;">
      <div class="container-fluid main-content" :class="{ active: isRightSidebarActive }">
        <!-- TKP-143: alt ekranlarda listeye dönüş kırıntısı -->
        <workspace-breadcrumb />
        <slot />
      </div>
    </main>
    <sidebar-right :rightSidebarActive="isRightSidebarActive" @toggle-sidebar="toggleSidebar">
      <sidebar-item />
    </sidebar-right>
    <Footer />
  </div>
</template>

<script>
import SidebarRight from "@c/sidebar-right";
import Footer from "../footer";
import NavBar from "./header";
import WorkspaceBreadcrumb from "./workspace-breadcrumb.vue";
import SideBar from "./side-bar";
import sidebarItem from "./workspace-sidebar-right-item.vue";

/**
 * Vertical layout
 */
export default {
  components: { NavBar, SideBar, Footer, SidebarRight, sidebarItem, WorkspaceBreadcrumb },
  data() {
    return {
      sidebarActiveTab: "notifications",
    };
  },
  computed: {
    isMenuCollapsed() {
      return this.$store.getters["layout/isMenuCollapsed"];
    },
    isRightSidebarActive() {
      return this.$store.getters["layout/isRightSidebarActive"];
    },
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
  },
  methods: {
    toggleSidebar() {
      this.$store.dispatch("layout/TOGGLE_RIGHT_SIDEBAR");
    },
    toggleMenu() {
      if (this.isMenuCollapsed) {
        document.body.classList.remove("vertical-collpsed");
      } else {
        document.body.classList.add("vertical-collpsed");
      }
      this.$store.dispatch("layout/toggleMenuCollapse");
    },
  },
  mounted() {
    if (this.isMenuCollapsed) {
      document.body.classList.add("vertical-collpsed");
    } else {
      document.body.classList.remove("vertical-collpsed");
    }
  },
};
</script>
